




















































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'
import AgendaGarantiaMinimaStore from '../financeiro/Store/AgendaGarantiaMinimaStore'
import _ from 'lodash'

@Component

export default class ComponentRemuneracaoAgendaGarantiaMinimaRightNavBar extends Vue {
  $refs: {
    menuDe: any,
    menuAte: any,
  }

  fltLoading: boolean = false
  menuDe: boolean = false
  menuAte: boolean = false
  searchPrestador: string = ''
  searchProfissional: any = ''
  profissionalName: string = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false
  loadingProfissionalFilter: boolean = false

  profissionaisDebounced = _.debounce(param => this.getStore.getPessoaProfissionalExecutanteAll(param), 500)
  prestadoresDebounced = _.debounce(async (param: string) => {
    await this.getStore.getAllPrestadoresByHospital({ filtro: param, limite: 20 })
    this.loadingPrestadorFilter = false
  }, 700)

  get getPrestadoresList() {
    return this.getStore.prestadoresList
  }

  get getProfissionaisList() {
    return this.getStore.pessoaProfissionalExecutanteList
  }

  get getTurno() {
    return this.getStore.periodosList
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(AgendaGarantiaMinimaStore, this.$store)
  }

  get drawer() {
    return this.getStore.agendaGarantiaMinimaDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setAgendaGarantiaMinimaDrawer(value)
  }

  get getMenuDe() {
    return this.menuDe
  }

  set getMenuDe(value: boolean) {
    this.menuDe = value
  }

  get getMenuAte() {
    return this.menuAte
  }

  set getMenuAte(value: boolean) {
    this.menuAte = value
  }

  get dataDe() {
    return this.getStore.dataDe
  }

  set dataDe(value) {
    this.getStore.setDataDe(value)
  }

  get dataAte() {
    return this.getStore.dataAte
  }

  set dataAte(value) {
    this.getStore.setDataAte(value)
  }

  get selectedPrestador() {
    return this.getStore.selectedPrestador
  }

  set selectedPrestador(value) {
    this.getStore.setSelectedPrestador(value)
  }

  get selectedProfissional() {
    return this.getStore.selectedProfissional
  }

  set selectedProfissional(value: any) {
    this.getStore.setSelectedProfissional(value ? value.userId : '')
  }

  get selectedTurno() {
    return this.getStore.selectedTurno
  }

  set selectedTurno(value) {
    this.getStore.setSelectedTurno(value)
  }

  get fontePagadorasList() {
    return this.getStore.fontesPagadorasList
  }

  get selectedEstabelecimento() {
    return this.getStore.selectedEstabelecimento
  }

  set selectedEstabelecimento(value) {
    this.getStore.setSelectedEstabelecimento(value)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setAgendaGarantiaMinimaPagina(1)
    this.getStore.getAllItemsAgendaGarantiaMinima()
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.selectedPrestador.length > 0 || this.getStore.selectedProfissional.length > 0 || (this.getStore.dataDe !== null) || (this.getStore.dataAte !== null) || this.getStore.selectedTurno.length > 0
  }

  async clear() {
    this.getStore.clearFiltroAvançado()
    this.getStore.setFilterOn(false)
    
    await this.search()
  }

   changeProfissionalExecutante(value) {
    if(value){
      this.profissionalName = value.nome
    } else {
      this.profissionalName = ''
    }
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3) {
      this.getStore.setPrestadoresList([])
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
  }

  @Watch('getPrestadoresList')
  onPrestadoresListChanged() {
    this.loadingPrestadorFilter = false
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {

    if (!val || val.length < 3){
      this.getStore.setPessoaProfissionalExecutanteList([])
      this.selectedProfissional = ''
      return
    }

    if(this.profissionalName === val){
      return
    } else {
      this.selectedProfissional = ''
    }
    
    this.loadingProfissionalFilter = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
